import request from "../../services/HTTPClient";
import { requestMethods, API } from "../../constants";

function AddAccount(request_body) {
  return request({
    url: API.ACCOUNTS.CREATE,
    method: requestMethods.POST,
    data: {
      ...request_body
    },
  });
}

function ListAccounts() {
  return request({
    url: API.ACCOUNTS.LIST,
    method: requestMethods.GET
  }).then(response => {
 
    if (!response) {
      throw new Error("No response from server");
    }

    if (Array.isArray(response)) {
      return { data: response };
    }
    if (response.data && Array.isArray(response.data)) {
      return response;
    }
    if (response.data && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }

    return { data: [] };
  });
}

function GetAccountById(id) {
  return request({
    url: `${API.ACCOUNTS.GET_BY}${id}`,
    method: requestMethods.GET

  });
}

function EditAccount(id, request_body) {
  return request({
    url: `${API.ACCOUNTS.EDIT}${id}`,
    method: requestMethods.PUT,
    data: {
      ...request_body
    },


  });
}
function DeleteAccount(id) {
  return request({
    url: `${API.ACCOUNTS.DELETE}${id}`,
    method: requestMethods.DELETE,   


  });
}
function GetAccountsByYear(year) {
  return request({
    url: `${API.ACCOUNTS.LIST}/year/${year}`,
    method: requestMethods.GET
  });
}

function GetAccountsByMonth(year, month) {
  return request({
    url: `${API.ACCOUNTS.LIST}/year/${year}/month/${month}`,
    method: requestMethods.GET
  });
}

const AccountService = {
  AddAccount,
  ListAccounts,
  GetAccountById,
  GetAccountsByYear,
  GetAccountsByMonth,
  EditAccount,
  DeleteAccount
};

export default AccountService;